module.exports = __webpack_public_path__ + "static/media/3 japanese theme anime manga .1280x1707.95b238ff.webp";